export default {
  add: 'Pridať',
  addAnotherCompany: 'Pridať ďalšiu spoločnosť',
  addCompany: 'Pridať spoločnosť',
  addPhoto: 'Pridať fotku',
  addService: 'Pridať službu',
  back: 'Späť',
  close: 'Zatvoriť',
  delete: 'Zmazať',
  detail: 'Zobraziť',
  edit: 'Upraviť',
  editPhoto: 'Nahrať novú fotku',
  forgotPassword: 'Zabudli ste heslo?',
  switchLanguage: 'Zmeniť jazyk',
  login: 'Prihlásiť',
  logout: 'Odhlásiť',
  logoutConfirm: 'Naozaj si prajete sa odhlásiť?',
  no: 'Nie',
  ok: 'OK',
  register: 'Registrovať',
  remove: 'Odstrániť',
  resendEmail: 'Zaslať email',
  save: 'Uložiť',
  send: 'Odoslať',
  select: 'Zvoliť',
  yes: 'Áno',
  upload: 'Nahrať',
  continue: 'Pokračovať'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/actions.js